const MITRA_PAYMENT_URL = '/mitra-payment';

/**
 * https://blueprint.bukalapak.io/t/mitra~payment~mitra~payment~get~mitra-payment~transactions
 * @param {import('@nuxtjs/axios').NuxtAxiosInstance} $axios
 * @param {object} param
 * @param {string} param.trxType - 'invoices' - 'buka20-transactions'
 * @returns {Promise}
 */
export const getMitraPaymentTransactions = ($axios, { trxType = '' }) =>
  $axios.$get(`${MITRA_PAYMENT_URL}/transactions`, {
    params: {
      trx_type: trxType,
      v: trxType === 'buka20-transactions' ? 2 : 1,
    },
  });
